// https://github.com/cferdinandi/smooth-scroll

var scroll = new SmoothScroll('a[data-scroll]');